// extracted by mini-css-extract-plugin
export default {"errorpage":"NotFound_errorpage__0o4qq"};